import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/VideoGrid.css";

// ✅ Fonction centrale pour corriger le chemin vidéo
const getVideoUrl = (filePath) => {
  if (!filePath) return "";

  return `/uploads/videos/${filePath
    .replace(/^\/+/, "")
    .replace(/^uploads\//, "")
    .replace(/^videos\//, "")}`;
};

function VideoGrid({ videos }) {
  const navigate = useNavigate();

  if (!videos || videos.length === 0) {
    return <div className="video-grid-empty">Aucune vidéo.</div>;
  }

  return (
    <div className="video-grid">
      {videos.map((v) => {
        const videoUrl = getVideoUrl(v.file_path);

        return (
          <div
            key={v.id}
            className="video-thumb"
            onClick={() => navigate(`/video/${v.id}`)}
          >
            <video
              className="thumb-img"
              src={videoUrl}
              muted
              playsInline
            />

            <div className="thumb-overlay">
              {v.likes ?? 0} ❤
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default VideoGrid;
